var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "message",
    staticClass: "shared-message"
  }, [_c('span', {
    staticClass: "level",
    style: {
      'background-image': _vm.getLevelImage(_vm.data.level)
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.data.level))])]), _vm._v(" "), _c('span', {
    staticClass: "name",
    on: {
      "click": _vm.openCardHandler
    }
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.data.content))])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };